import { Button, Modal } from "@themesberg/react-bootstrap";
import React from "react";

export const Model = (props)=>{
    const {show, children, size = "md"} = props;
    return(
        <React.Fragment>
            <Modal as={Modal.Dialog} show={show} backdrop="static" size={size}>
                <Modal.Body>
                    {children}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}